/** 오른쪽 원형 아이콘 면(지름 60 = `size.icon-circle`, StatCard 와 같다) */
export const FUND_METRIC_ICON_CIRCLE_CLASS =
  'inline-flex size-(--size-icon-circle) shrink-0 items-center justify-center rounded-full bg-bg-secondary-subtle';

/** 값이 둘인 kind 의 값 줄 간격: 쌍 사이 · 쌍 안 (irr · exit-count 20 · 8, rvpi-dpi 16 · 4) */
export const FUND_METRIC_PAIR_GAP_CLASS = {
  wide: { row: 'gap-5', pair: 'gap-2' },
  narrow: { row: 'gap-4', pair: 'gap-1' },
} as const;
